import React from 'react';
import { design, spacing, getActiveTheme, isLocalOnlyThemeName } from '../ui/tokens';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import ActiveUsersAvatars from './ActiveUsersAvatars';

export default function Layout({ user, darkMode, setDarkMode, onLogout, theme, onThemeChange }) {
  const localOnly = isLocalOnlyThemeName(theme);
  const activeTheme = getActiveTheme();
  const pageBg = activeTheme?.bg || (darkMode ? design.dark.colors.bgPage : design.light.colors.bgPage);
  const contentBg = localOnly ? 'transparent' : pageBg;

  const cssVars = {
    '--ui-bg': activeTheme?.bg || '#F4F6F9',
    '--ui-surface': activeTheme?.surface || '#FFFFFF',
    '--ui-surface2': activeTheme?.surface2 || '#EEF1F6',
    '--ui-border': activeTheme?.border || '#E5E9F0',
    '--ui-text': activeTheme?.text || '#1F2937',
    '--ui-text-muted': activeTheme?.mutedText || '#6B7280',
    '--ui-text-disabled': activeTheme?.disabledText || '#9CA3AF',
    '--ui-primary': activeTheme?.primary || '#5063A8',
    '--ui-primary-hover': activeTheme?.primaryHover || '#4457A0',
    '--ui-primary-soft': activeTheme?.primarySoft || 'rgba(80,99,168,0.08)',
    '--ui-selected': activeTheme?.selected || activeTheme?.primary || '#5063A8',
    '--ui-success': activeTheme?.success || '#8FBFB9',
    '--ui-danger': activeTheme?.danger || '#B71C1C',
    '--ui-danger-hover': activeTheme?.dangerHover || '#9A1717',
    '--ui-focus-ring': activeTheme?.focusRing || 'rgba(80,99,168,0.3)',
    '--ui-card-shadow': activeTheme?.cardShadow || '0 1px 2px rgba(0,0,0,0.08)',
    '--ui-card-shadow-hover': activeTheme?.cardShadowHover || '0 6px 16px rgba(0,0,0,0.15)',
    '--ui-radius-card': String(activeTheme?.cardRadius || 10),
  };

  return (
    <div
      data-ui-theme={theme}
      className={(darkMode ? 'dark ' : '') + 'flex min-h-screen'}
      style={{ background: pageBg, ...cssVars }}
    >
      <Sidebar user={user} darkMode={darkMode} setDarkMode={setDarkMode} theme={theme} onThemeChange={onThemeChange} />
      <div
        className="flex-1 flex flex-col"
        style={{
          background: contentBg,
          padding: spacing.xl,
          color: activeTheme?.text || undefined,
        }}
      >
        <div className="flex items-center justify-end mb-4 gap-2">
          <ActiveUsersAvatars minutes={5} />
          <button
            onClick={onLogout}
            className="ui-btn px-3 py-1 rounded bg-red-500 text-white hover:bg-red-600 text-sm"
          >
            Logout
          </button>
        </div>
        <div className="flex-1 min-h-0" style={{ maxWidth: 1120, margin: '0 auto' }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}
